import {
  ExclamationTriangleIcon,
  BarChartIcon,
  ArrowUpIcon,
  FileTextIcon,
  StackIcon,
  CardStackIcon,
} from '@radix-ui/react-icons';
import type { PickupTileData } from './pickup-tile';

export const PICKUP_TILES: PickupTileData[] = [
  {
    icon: ExclamationTriangleIcon,
    color: 'red',
    title: 'Reorder Alerts',
    subtitle: 'Products running low that need replenishment',
    prompt: 'What do I need to order this week? Next week?',
  },
  {
    icon: BarChartIcon,
    color: 'blue',
    title: 'Inventory Health',
    subtitle: 'Overall stock levels and days-on-hand',
    prompt: 'Give me a full inventory health check across all categories.',
  },
  {
    icon: ArrowUpIcon,
    color: 'green',
    title: 'Sales Velocity',
    subtitle: 'Top-moving products and demand trends',
    prompt: 'Show me my fastest and slowest selling products this month.',
  },
  {
    icon: FileTextIcon,
    color: 'purple',
    title: 'Draft a PO',
    subtitle: 'Build a purchase order from recommendations',
    prompt: 'I want to maintain 30 days of stock on my best sellers. What should I be ordering?',
  },
  {
    icon: StackIcon,
    color: 'orange',
    title: 'Overstock Check',
    subtitle: 'Excess inventory and slow movers',
    prompt: 'Are there any products that I consistently overorder?',
  },
  {
    icon: CardStackIcon,
    color: 'cyan',
    title: 'Open Orders',
    subtitle: 'Track pending purchase orders',
    prompt: 'Show me all open purchase orders and their delivery status.',
  },
];
